<template>
  <section class="form-section">
    <div class="row align-justify">
      <div class="small-12 columns">
        <div class="card register-done">
          <div class="card__block">
            <div class="card__header register-done__header">
              <div class="register-done__success-badge">
                <i class="el-icon-check" />
              </div>
            </div>
            <div>
              {{ $t('AUTH.STEPS.DONE.MESSAGE') }}
            </div>
            <div class="register-done__link">
              <RouterLink :to="{ name: 'apps' }">
                {{ $t('AUTH.STEPS.DONE.GO_HOME') }}
              </RouterLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Done',
};
</script>

<style lang="scss">
.register-done {
  text-align: center;

  &__header {
    display: flex;
    justify-content: center;
  }

  &__success-badge {
    width: 100px;
    height: 100px;
    border: 1px solid #008000;
    color: #008000;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 50px;
  }

  &__link {
    padding: 10px 0;
    font-weight: bold;
  }
}
</style>
